import ResizeObserver from 'resize-observer-polyfill';
import EventEmit from '@oppobrowser/lib-browser-eventEmit';
import Event from '@oppobrowser/lib-browser-event';
import { $, asyncLoadJs, throttle } from '@js/utils';
import Metrics from '@cpc/lib-metrics-report';

import { stat } from '../../js/utils';
import { BrowserBridgeHandler } from '../../js/browserBridgeHandler';
import {
  channel,
  isNewPush,
  pushId,
  enterId,
  isShieldFirstAd,
  browserPartner,
  iflowScene,
} from '../../js/constants';
import './index.scss';

const AdStatus = {
  LOAD_JS_ERROR: 0,
  NO_AD: 1,
  SUCC: 2,
};
const EventHandler = {};
async function getAdKeys() {
  const brand = await BrowserBridgeHandler.getBrand();
  const adkeys = window.pageData.adkeys[brand];
  return adkeys || ['18620_18685_21155_377400', '18620_18685_21155_377401'];
}

const metricsSdk = new Metrics({
  env: window.pageData?.COMMON?.CODE_ENV || process.env.NODE_ENV,
  appid: 'flow-fe-server',
  target: 'ad_request_metric',
});
export default class Ad {
  constructor(el) {
    this.el = el;
    this._eventHandler = {};
    this.relatedNewsLoaded = false;
    this.relatedReadingLoaded = false;
    this.ids = [];
    this.posIds = [];
    this.renderedIds = [];
    this.renderedPosIds = [];
    this.adReady = false;
    this.adLoaded = false; // 广告是否已经加载
    const { adShield } = window.store;
    const showAllAd = adShield.length === 0;
    // this.canInsertCommentAd = showAllAd || adShield[adShield.length - 1] === '0';
    // this.canInsertFirstAd = (showAllAd || adShield[0] === '0') && !isShieldFirstAd();
    this.canInsertFirstAd = window.modulesConfig?.ad_afterArticle?.isShow;
    // this.canInsertShareAd = showAllAd || adShield[0] === '0';
    this.canInsertRelatedNewsAd =
      window.modulesConfig?.ad_afterRelatedNews?.isShow;
    this.adJs = window.pageData.COMMON.contentAdSdkUrl || '';

    this.renderAd = throttle(this.renderAd.bind(this), 600, true); // 节流 但是保证最后一次会调用 this.renderAd
  }

  async init() {
    this.adKeys = await getAdKeys();
    if (this.canInsertFirstAd) {
      this.addAd('flow-ad-detail-1', this.adKeys[0]);
    }

    const that = this;
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();

    // 广告加载完成后加载额外样式
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // 注意避免一直触发属性变化 会导致死循环
        const hasBorder = mutation.target.classList.contains('feeds-ad-border');
        if (!hasBorder) {
          mutation.target.classList.add('feeds-ad-border');
        }
        this.notify(AdStatus.SUCC);
      });
    });

    // 监测到高度变化后需要处理的逻辑
    this.resizeObserver = new ResizeObserver((entries) => {
      EventEmit.instance.emit('ad-resize');
    });

    if (this.canLoadAd) {
      // 相关新闻、分享模块的广告 调用广告JSSDK执行广告请求、渲染的逻辑
      window.libJsRequire.scriptOnReady({
        url: window.pageData.adSdkUrl,
        namespace: 'heyTapAdInvoke',
        callback: () => {
          this.adReady = true;
          this.renderAd();
        },
      });

      // asyncLoadJs(this.adJs)
      //   .then(() => {
      //     this.adReady = true;
      //     this.renderAd();
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //     this.notify(AdStatus.LOAD_JS_ERROR);
      //   });

      // 广告显隐切换逻辑
      EventEmit.instance.on('ad-visible', (index = 1, isShow = true) => {
        setTimeout(() => {
          const adDom = $(`#flow-ad-detail-${index}`);
          adDom && (adDom.style.display = isShow ? 'block' : 'none');
        }, 0);
      });

      // 新版push详情页 折叠时先隐藏广告 点击展开全文时展示
      window.store.isShowFold.isShow &&
        channel &&
        isNewPush &&
        EventEmit.instance.emit('ad-visible', 1, false);

      // 点击展示全文时触发
      EventEmit.instance.on('showMore', () => {
        channel && isNewPush && EventEmit.instance.emit('ad-visible', 1, true);
      });

      // 根据各个组件加载情况来加载广告，relatedNews和relatedReading组件是互斥的，页面只会加载一个
      EventEmit.instance.on('component-loaded', (type, cbData) => {
        if (type === 'relatedNews') {
          that.relatedNewsLoaded = true;
          if (cbData.data.length > 0 && that.canInsertRelatedNewsAd) {
            that.addAd('flow-ad-detail-2', this.adKeys[1]);
          } else {
            this.renderAd();
          }
        } else if (type === 'relatedReading') {
          that.relatedReadingLoaded = true;
          if (that.canInsertRelatedNewsAd) {
            that.addAd('flow-ad-detail-2', this.adKeys[1]);
          } else {
            this.renderAd();
          }
        }
      });
    } else {
      this.notify(AdStatus.NO_AD);
    }
    this.registerNightModeHandler();
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }

  /**
   * 通知其他组件广告已经加载完成
   * @param status 0-错误，1-不需要加载，2-加载完成
   */
  notify(status) {
    this.adLoaded = true;
    EventEmit.instance.emit('ad-loaded', status);
  }

  addAd(id, posId) {
    this.ids.push(id);
    this.posIds.push(posId);
    this.renderAd();
  }

  renderAd() {
    if (!this.adReady || this.ids.length === 0 || this.adLoaded) {
      return console.log('renderAd return1');
    }

    // 广告加载完成后需要添加额外样式
    this.ids.forEach((id) => {
      const node = $(`#${id}`);
      if (node) {
        this.observer.observe(node, {
          childList: true, // 子节点的变动（新增、删除或者更改）
          // attributes: true, // 属性的变动
          // subtree: true, // 是否将观察器应用于该节点的所有后代节点
          // characterData: true, // 节点内容或节点文本的变动
          // attributeFilter: ['class', 'style'], // 观察特定属性
          // attributeOldValue: true, // 观察 attributes 变动时，是否需要记录变动前的属性值
          // characterDataOldValue: true // 观察 characterData 变动，是否需要记录变动前的值
        });

        this.resizeObserver.observe(node);
      }
    });

    const { source, sourceVal, docId, title, publishTime } = window.store;

    const data = {
      posIds: this.posIds, // 分配的广告位id
      id: this.ids, // 需要渲染广告的dom id
      pageId: `${source}_${docId}`, // 必填，页面id，用于区分页面
      source: sourceVal, // 必填，文章分发算法来源
      docSource: sourceVal == 'tencent' ? '腾讯' : 'OPPO', // 必填，文章内容来源 ???
      docUrl: window.location.href, // 选填，文章地址
      docTitle: title, // 选填，文章标题
      keywords: [], // 选填，文章关键词，若无为空数组
      publishTime: publishTime, // 选填，文章发布时间，传入毫秒值
      docCat: [], // 选填，文章类别
      devId: '', // 选填，开发者id
      docId: docId, // 选填，文章id
      customSpecs: false, // 选填，布尔值，是否自定义广告规格
      supportSpecs: '', // 当customSpecs为true时必填
      customTypes: false, // 选填，布尔值，是否自定义广告类型
      supportTypes: '', // 当customTypes为true时必填
      isCommentAd: false, // 是否为评论区广告，因为非评论区与评论区广告样式有区别，因此需要明确是否需要按照评论区广告渲染
      enterId: browserPartner, // 广告启动归因参数
      parmoduleId: iflowScene, // 广告上级页面归因
      renderCb: (status) => {
        EventEmit.instance.emit('ad-loaded-callback', status);
      }, // 广告渲染的回调，广告渲染成功或失败都会触发此函数
      closeCb: (...arg) => {
        EventEmit.instance.emit('ad-close', arg);
      }, // 当用户因广告负反馈功能关闭广告时触发
      style: 'content',
      outSourceCn: source,
    };

    console.log(
      'renderAd-this.posIds, this.ids params',
      this.posIds,
      this.ids,
      data,
    );

    let adStyle = document.querySelector('#flow-ad-detail-1');

    // 判断是否负一屏跳过来的,如果是则需要加样式,否则去除
    if (window.store.isShowFold.isShow) {
      if (adStyle) {
        adStyle.classList.add('mt');
      }
    } else {
      adStyle.classList.remove('mt');
    }

    this.addInvokeMetric(data);

    window
      .heyTapAdInvoke(data)
      .then((res) => {
        console.log('评论上方回调heyTapAdInvoke成功->res==', res); // 处理渲染的回调
        Array.isArray(res) &&
          res.forEach((item) => {
            const statData = {
              mainDocId: docId,
              url: location.href,
              traceId: item.traceId,
              pushId: pushId,
              enterId: enterId,
            };
            stat(20084838, 10012, 21006, statData);
          });

        this.addRenderCallback(data, res);
      })
      .catch((err) =>
        console.log('评论上方回调heyTapAdInvoke失败->err==', err),
      );

    this.clearAd();
  }

  clearAd() {
    this.renderedIds = this.renderedIds.concat(this.ids);
    this.renderedPosIds = this.renderedPosIds.concat(this.posIds);
    this.ids = [];
    this.posIds = [];
  }

  addInvokeMetric(data) {
    if (!data.posIds.length) {
      return;
    }

    const { pageType } = window.store;

    const metrics = [];
    data.posIds.forEach((posId, index) => {
      metrics.push({
        enterId: enterId,
        scene: window.FEEDSMC_CURRENT_SCENE,
        pageType: pageType,
        iflowSource: data.source,
        adId: posId,
      });
    });

    metricsSdk.addMetric('invoke_ad_render', 1, 'detail_base', metrics);
  }

  addRenderCallback(data, res) {
    if (!data.posIds.length) {
      return;
    }

    const { pageType } = window.store;

    const metrics = [];
    data.posIds.forEach((posId, index) => {
      metrics.push({
        enterId: enterId,
        scene: window.FEEDSMC_CURRENT_SCENE,
        pageType: pageType,
        iflowSource: data.source,
        adId: posId,
        callbackCode: res?.[index]?.result?.toString?.(),
      });
    });

    metricsSdk.addMetric('ad_render_callback', 1, 'detail_base', metrics);
  }

  get canLoadAd() {
    const { docId, pageType, noAd } = window.store;
    return (
      this.adJs &&
      docId &&
      noAd !== '1' &&
      pageType !== 'comment' &&
      pageType !== 'second-comment'
    );
  }

  //夜间模式监听
  registerNightModeHandler() {
    this._nightModeHandler();
    window.document.addEventListener('nightmodechange', () => {
      this._nightModeHandler();
    });
  }

  _nightModeHandler() {
    let adList = document.querySelectorAll('.feeds-ad-common');
    // console.log(adList,'adList')
    if (window.store.nightMode) {
      adList.forEach((item) => {
        item.classList.add('feeds-ad-border-dark');
      });
    } else {
      adList.forEach((item) => {
        item.classList.remove('feeds-ad-border-dark');
      });
    }
  }

  render() {}
}
